import { z } from 'zod'

import { AuthTokensShort } from '@/types/auth/tokens'
import { ManagerBinding } from '@/types/park/manager'
import { User } from '@/types/user'

/** The response body at user log in. */
export const LoginResponse = AuthTokensShort.extend({
    machine_user_id: z.number(),
    credit: z.number(),
    hasCardRegistered: z.boolean(),
    client: ManagerBinding,
})

export type LoginResponse = z.infer<typeof LoginResponse>

/** Form needed to login the konvive. */
export const LoginPayload = User.pick({
    email: true,
}).extend({
    /** Password to authenticate. */
    password: z.string().min(1),
})

export type LoginPayload = z.infer<typeof LoginPayload>
